// Deferred and first in core-assets, so it runs after the JSON blocks at the end
// of body are parsed but before any other deferred script reads the strings.
window.theme = window.theme || {};

const rawThemeStrings = JSON.parse(document.getElementById('theme-strings').textContent);
const decodeHtmlEntities = (value) => new DOMParser().parseFromString(value, 'text/html').documentElement.textContent;

window.theme.strings = Object.fromEntries(
  Object.entries(rawThemeStrings).map(([key, value]) => [key, decodeHtmlEntities(value)]),
);
